import { IProductFormValues } from '../../../../common/validations/product.validations';

/**
 * Default values for product form fields
 * Consolidated from all form components (ProductDetails, PeriodDetails, TotalSection)
 */

// Default linked tool (from ProductDetails)
export const DEFAULT_LINKED_TOOL = {
  id: 1,
  name: 'Coro',
  image: '/images/attack-surface/generic2.svg',
};

// Default supplier (from ProductDetails)
export const DEFAULT_SUPPLIER = {
  id: 1,
  name: 'M3 Networks',
};

// Default manufacturer (from ProductDetails)
export const DEFAULT_MANUFACTURER = {
  id: 1,
  name: 'M3 Networks',
};

// Default billing period options (from PeriodDetails)
export const BILLING_PERIODS = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annually', value: 'Annually' },
] ;

// Default billing period value
export const DEFAULT_BILLING_PERIOD = 'Monthly';

// Default snap to unit value
export const DEFAULT_SNAP_TO_UNIT = 'Monthly';

// Default monitored by SOC value
export const DEFAULT_MONITORED_BY_SOC = 'Monthly';

// Default time unit options (from PeriodDetails)
export const TIME_UNITS = [
  { label: 'Months', value: 'Months' },
  { label: 'Years', value: 'Years' },
] ;

// Default contract term unit
export const DEFAULT_CONTRACT_TERM_UNIT = 'Months';

// Default currency options (from TotalSection)
export const CURRENCY_OPTIONS = [
  { label: 'GBP', value: 'GBP' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
];

// Default currency
export const DEFAULT_CURRENCY = 'GBP';

// Default tax rate options (from TotalSection)
export const TAX_RATES = [
  { label: 'VAT-10%', value: 'VAT-10%' },
  { label: 'VAT-15%', value: 'VAT-15%' },
  { label: 'VAT-20%', value: 'VAT-20%' },
];

// Default tax rate
export const DEFAULT_TAX_RATE = 'VAT-10%';

// Default cost amount
export const DEFAULT_COST = '0.00';

// Default USD amount
export const DEFAULT_USD_AMOUNT = '0.00';

// Default GBP amount
export const DEFAULT_GBP_AMOUNT = '0.00';

// Exchange rate (from TotalSection)
export const EXCHANGE_RATE = 0.79;

/**
 * Get initial values for the product form
 * Consolidates all default states from ProductDetails, PeriodDetails, and TotalSection components
 */
export const getProductFormInitialValues = (): IProductFormValues => ({
  // Product Details
  productName: '',
  productSku: '',
  linkedTools: [DEFAULT_LINKED_TOOL],
  category: null,
  subcategory: null,
  suppliers: [DEFAULT_SUPPLIER],
  manufacturers: [DEFAULT_MANUFACTURER],

  // Period Details
  licenseQty: '',
  billingPeriod: DEFAULT_BILLING_PERIOD,
  snapToUnit: DEFAULT_SNAP_TO_UNIT,
  contractTerm: '',
  contractTermUnit: DEFAULT_CONTRACT_TERM_UNIT,
  contractEnd: '',
  monitoredBySoc: DEFAULT_MONITORED_BY_SOC,
  periodManufacturers: [],

  // Total Section
  currency: DEFAULT_CURRENCY,
  cost: DEFAULT_COST,
  taxRate: DEFAULT_TAX_RATE,
  usdAmount: DEFAULT_USD_AMOUNT,
  gbpAmount: DEFAULT_GBP_AMOUNT,
});

